<div class="inline-card" *ngIf="product" [class.inline-card--reco]="!readonly">
  <ng-container *ngIf="readonly; else linkedContent">
    <ng-container *ngTemplateOutlet="productLine"></ng-container>
  </ng-container>

  <ng-template #linkedContent>
    <a
      class="inline-card__link"
      [routerLink]="getUrlAndParams(product.url).url"
      [queryParams]="getUrlAndParams(product.url)?.queryParams"
      [fragment]="getUrlAndParams(product.url)?.fragment"
      (click)="onProductLinkClick()"
    >
      <ng-container *ngTemplateOutlet="productLine"></ng-container>
    </a>

    @if (addToCartFinished) {
      <div
        class="btn w-100 inline-card__add-btn inline-card__added"
        data-qa="cart-popup-reco-added"
      >
        <span>{{ 'habaAddToCartPopup.added' | cxTranslate }}</span>
        <app-svg dimension="1.5rem" transition="none" iconName="check"></app-svg>
      </div>
    } @else {
      <button
        type="button"
        class="btn btn-primary w-100 inline-card__add-btn"
        data-qa="cart-popup-reco-add"
        (click)="onAddToCart($event)"
      >
        <span>{{ 'habaAddToCartPopup.add' | cxTranslate }}</span>
        <app-svg dimension="1.25rem" transition="none" iconName="cart-new"></app-svg>
      </button>
    }
  </ng-template>
</div>

<ng-template #productLine>
  <div class="inline-card__product">
    <div class="inline-card__image">
      <app-image
        [cloudinaryId]="personalizationImage ?? product.images?.[0]?.cloudinaryPublicId"
        [alt]="product.images?.[0]?.altText || product.name"
        [size]="ImageSizes.MINI_CART"
      ></app-image>
    </div>

    <div class="inline-card__info">
      <div class="inline-card__name" [innerHTML]="product.name || '&nbsp;'"></div>

      <div class="inline-card__price-container" *ngIf="product.priceFormatted">
        <span
          class="inline-card__price"
          [class.color-red-secondary]="product.strikeThroughPriceFormatted"
        >
          {{ product.priceFormatted }}
        </span>
        <span class="inline-card__strike-price" *ngIf="product.strikeThroughPriceFormatted">
          {{ product.strikeThroughPriceFormatted }}
        </span>
      </div>

      <div class="inline-card__quantity" *ngIf="readonly">
        {{ 'habaAddToCartPopup.quantity' | cxTranslate }}&nbsp;{{ quantity }}
      </div>
    </div>
  </div>
</ng-template>
